const Text = ({ text }) => {
    return <span>{text}</span>;
};

export default Text;


// WEBPACK FOOTER //
// ./src/components/TableColumns/Text/Text.js